import { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { adapter } from "@/services/db";
import { useAuth } from "@/context/AuthContext";
import { TradePicker, tradesOfPro } from "@/components/catalog/ProCategoriesTab";

// The professional categories (trades) this pro works in → which leads reach them.
// Saved to professionals/{id}.pro_category_ids; Command Centre then adds every linked service to
// their category_ids (what the lead float matches on) within a few seconds.
export function ProTrades({ pro, procats, categories }) {
  const { user } = useAuth();
  const explicit = Array.isArray(pro.pro_category_ids) && pro.pro_category_ids.length > 0;
  const [val, setVal] = useState(tradesOfPro(pro, procats));
  const [busy, setBusy] = useState(false);
  useEffect(() => { setVal(tradesOfPro(pro, procats)); }, [pro, procats]);
  const dirty = JSON.stringify([...val].sort()) !== JSON.stringify([...tradesOfPro(pro, procats)].sort()) || (!explicit && val.length > 0);
  const services = categories.filter((c) => (c.pro_category_ids || []).some((t) => val.includes(String(t)))).map((c) => c.name);
  const save = async () => {
    setBusy(true);
    try {
      await adapter.update("professionals", pro.id, { pro_category_ids: val, updated_at: new Date().toISOString() });
      adapter.add("activity_logs", { app: "ops", entity_type: "professional", entity_id: pro.id, action: "pro_categories_set", change_type: "update", description: `Professional categories: ${val.map((id) => procats.find((t) => t.id === id)?.name || id).join(", ") || "none"}`, performed_by: user?.email || null, performed_by_role: user?.role || null, status: "applied", created_at: new Date().toISOString() }).catch(() => {});
      toast.success("Saved — their leads update in a few seconds");
    } catch (e) { toast.error(e?.code === "permission-denied" ? "Permission denied — ops or admin role required" : e.message); } finally { setBusy(false); }
  };
  if (!procats.length) return null;
  return (
    <div className="mt-4 rounded-lg border border-border p-3 space-y-2" data-testid="pro-trades">
      <p className="text-sm font-semibold flex items-center gap-1.5"><Icons.HardHat className="h-4 w-4 text-primary" />Professional categories</p>
      <TradePicker value={val} onChange={setVal} procats={procats} testId="pro-trade" />
      <p className="text-[11px] text-muted-foreground">
        {explicit ? "Set here." : val.length ? "Worked out from their main category — save to fix it." : "None yet."}
        {" "}Gets leads for: {services.length ? services.join(", ") : <span className="text-amber-700">no linked services</span>}
      </p>
      {dirty && <Button size="sm" onClick={save} disabled={busy} data-testid="pro-trades-save">{busy ? "Saving…" : "Save"}</Button>}
    </div>
  );
}
